import { TimeUnit } from 'chart.js';

import { TimeSeriesGranularity } from 'dashboards/types/time';

export const TIME_UNIT_MAP: Record<TimeSeriesGranularity, TimeUnit | false> = {
  YEAR: 'year',
  MONTH: 'month',
  WEEK: 'week',
  DAY: 'day',
  HOUR: 'hour',
  MINUTE: 'minute',
  FIVE_MINUTES: false,
  TEN_MINUTES: false,
  FIFTEEN_MINUTES: false,
};
